import { render, staticRenderFns } from "./edit-org-modal.vue?vue&type=template&id=0d9ef0d8&"
import script from "./edit-org-modal.vue?vue&type=script&lang=js&"
export * from "./edit-org-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports